// extracted by mini-css-extract-plugin
module.exports = {"submit":"Q-LsN7","tooltip":"_6I3zBY","ftueContainer":"_2WzXWN","ftueHeader":"_2EkaGv","ftueBody":"_1ePP6X","watchPartyButtonWrapper":"_3MJJah","watchPartyButton":"_3BLJBW"};